/** @jsxImportSource @emotion/react */
import { FormikHelpers } from 'formik';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { OrganizerUpsertPayload } from 'modules/organizer/domain/interfaces/organizer-upsert-payload';
import { UpsertOrganizerInput } from 'modules/organizer/domain/interfaces/upsert-organizer-input';
import { upsertOrganizer } from 'modules/organizer/store/orginizer/actions';
import { OrganizerForm, OrganizerFormValues } from 'modules/organizer/ui/components/organizer-form';
import { SkeletonOrganizerForm } from 'modules/organizer/ui/components/organizer-form/skeleton-organizer-form';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from 'store/store';
import { Organizer } from 'modules/organizer/domain/interfaces/organizer';

function Profile() {
  const dispatch = useDispatch<AppDispatch>();

  const { isLoading: loading, info, isSaving } = useOrganizer();
  const { user } = useAuth();

  const values = ({ email: user?.email, ...info } as Organizer) || undefined;

  const handleOrganizerSubmit = useCallback(
    (data: OrganizerUpsertPayload, formikHelpers: FormikHelpers<OrganizerFormValues>) => {
      const { logo, ...restData } = data;

      const params = {
        ...restData,
        adminUserId: user!.id,
        sportType: data.sportType.toString().toUpperCase(),
        logo: logo && logo[0].img instanceof File ? logo[0].img : undefined,
        background: logo && logo[0] ? logo[0].background : undefined,
      } as UpsertOrganizerInput;

      dispatch(upsertOrganizer(params))
        .unwrap()
        .finally(() => {
          formikHelpers.setSubmitting(false);
        });
    },
    [dispatch, user],
  );

  if (loading) {
    return <SkeletonOrganizerForm />;
  }

  return <OrganizerForm isLoading={isSaving} initialValues={values} onSubmit={handleOrganizerSubmit} />;
}

export default Profile;
